import Textarea from './textarea'

Textarea.install = vue => {
  vue.component(Textarea.name, Textarea)
}

export default Textarea
